import React, {
	memo, useMemo,
	useState,
} from 'react';
import { Variants } from 'console-feed-optimized/lib/definitions/Component';
import { Console } from 'console-feed-optimized';
import { IconChevronUpThick } from '@sololearnorg/sol';

import useStyles from 'isomorphic-style-loader/useStyles';

import classNames from 'classnames';
import { SlDataService } from '../../../services/sl-data.service';

import s from './OutputConsole.scss';
import { CONSOLE_STYLES } from '../../../../../shared/public/SlCodeEditorComponents/types/types';
import { lePlaygroundContext } from '../../../global-constants';
import { useContainerData } from '../../../../../shared/public/SlHooks/useContainerData';

export interface OutputConsoleProps {
	isDarkMode?: boolean;
}

export const OutputConsole: React.FC<OutputConsoleProps> = memo(
	({ isDarkMode = true }) => {
		useStyles(s);
		const { outputConsole$: outputConsole, isTIYExpanded } = useContainerData(lePlaygroundContext.value, SlDataService, ['outputConsole$', 'isTIYExpanded']);

		const style = useMemo(() => {
			if (isDarkMode) {
				return {
					mode: 'dark',
					output: CONSOLE_STYLES.DARK,
				};
			}
			return {
				mode: 'light',
				output: CONSOLE_STYLES.LIGHT,
			};
		}, [isDarkMode]);

		const [isCollapsed, setIsCollapsed] = useState(false);

		return (
			<div className={`sl-console sl-console__${style.mode}`}>
				<div
					className={classNames('sl-console__header', {
						collapsed: isCollapsed,
						isTIYExpanded,
					})}
				>
					<span className="sl-console__header__title">CONSOLE</span>
					{!isTIYExpanded && (
						<IconChevronUpThick
							onClick={() => setIsCollapsed(!isCollapsed)}
							className={classNames('sl-console__header__collapse-icon', {
								collapsed: isCollapsed,
							})}
						/>
					)}
				</div>
				<div className={classNames('sl-console__output', {
					collapsed: isCollapsed,
				})}
				>
					<div
						className={`sl-console__output__items sl-console__output__items__${style.mode}`}
					>
						{outputConsole && (
							<Console
								logs={outputConsole as any}
								variant={style.mode as Variants}
								styles={style.output}
							/>
						)}
					</div>
				</div>
			</div>
		);
	},
);
